var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished"},[_c('div',{staticClass:"finish-icon"}),_c('div',{staticClass:"finish-text"},[_vm._v("感谢您的评价")])])}]

export { render, staticRenderFns }